// extracted by mini-css-extract-plugin
export default {"gridContainer":"RejectedList_gridContainer__BePCQ"};